/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faint_Rust_Snail_AidInputs */

const en_faint_rust_snail_aid = /** @type {(inputs: Faint_Rust_Snail_AidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adding user`)
};

const de_faint_rust_snail_aid = /** @type {(inputs: Faint_Rust_Snail_AidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer wird hinzugefügt`)
};

/**
* | output |
* | --- |
* | "Adding user" |
*
* @param {Faint_Rust_Snail_AidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const faint_rust_snail_aid = /** @type {((inputs?: Faint_Rust_Snail_AidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faint_Rust_Snail_AidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faint_rust_snail_aid(inputs)
	return de_faint_rust_snail_aid(inputs)
});